// extracted by mini-css-extract-plugin
module.exports = {"card_container":"Card_card_container__3BaFH","row":"Card_row__1HNu_","types":"Card_types__3u-CM","outside_div":"Card_outside_div__2eK05","link":"Card_link__2DcM5"};